import { createSlice } from '@reduxjs/toolkit'

// Safe JSON parse helper
const safeJSONParse = (item, defaultValue) => {
    try {
        const parsed = localStorage.getItem(item);
        return parsed ? JSON.parse(parsed) : defaultValue;
    } catch (error) {
        return defaultValue;
    }
};

// Safe localStorage getters with defaults
const name = safeJSONParse("name", "");
const user = safeJSONParse("user", {
    name: "", 
    username: "",
    email: "",
    permission: "",
});
const isLoggedIn = safeJSONParse("isLoggedIn", false);

const initialState = {
    isLoggedIn,
    name,
    user,
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        SET_LOGIN(state, action) {
            state.isLoggedIn = action.payload;
            localStorage.setItem('isLoggedIn', JSON.stringify(action.payload));
            if (action.payload) {
                localStorage.setItem('sessionTimestamp', Date.now().toString());
            }
        },
        SET_NAME(state, action) {
            state.name = action.payload;
            localStorage.setItem("name", JSON.stringify(action.payload));
        },
        SET_USER(state, action) {
            const profile = action.payload;
            // Sanitize user data - remove sensitive fields that should never be stored
            const sanitizedProfile = {
                _id: profile._id,
                name: profile.name,
                username: profile.username,
                email: profile.email,
                permission: profile.permission
            };
            state.user = sanitizedProfile;
            localStorage.setItem("user", JSON.stringify(sanitizedProfile));
            localStorage.setItem('activeUserId', profile._id);
        },
        LOGOUT(state) {
            state.isLoggedIn = false;
            state.name = "";
            state.user = {
                name: "",
                username: "",
                email: "",
                permission: "",
            };
            // Clear all auth data from localStorage
            localStorage.removeItem('isLoggedIn');
            localStorage.removeItem('name');
            localStorage.removeItem('user');
            localStorage.removeItem('activeUserId');
            localStorage.removeItem('sessionTimestamp');
            // Also clear any other auth-related data that might exist
            localStorage.removeItem('token');
            localStorage.removeItem('password');
        }
    }
});

export const {SET_LOGIN, SET_NAME, SET_USER, LOGOUT} = authSlice.actions;

export const selectIsLoggedIn = (state) => state.auth.isLoggedIn;
export const selectName = (state) => state.auth.name;
export const selectUser = (state) => state.auth.user;

export default authSlice.reducer;